<!-- 合伙人入驻流程窗口 -->
<style lang="scss" scoped>
.empty-box {
  height: 520px;
  background-color: #f2f2f2;
}
:deep() {
  .el-step__icon.is-icon {
    width: 0;
  }
  .el-step__head {
    height: 24px;
  }

  // 基础样式
  .el-step__line {
    background-color: #d9d9d9;
    height: 3px !important;
  }

  .el-step__line-inner {
    height: 3px !important;
    background-color: inherit;
  }

  // 完成状态样式
  .is-finish .el-step__line {
    background-color: #002fbe;
  }

  .el-step__title {
    &.is-process {
      color: #333333 !important;
      font-weight: normal !important;
    }
  }
}
</style>

<style lang="scss">
.partner-join-process-dialog-wrapper {
  padding: 0 !important;

  .el-dialog__header {
    padding: 16px;
    .el-dialog__title {
      font-size: 18px;
      font-weight: 500;
    }
  }

  .el-dialog__body {
    background: #f2f2f2;
    padding: 20px;
  }

  .el-dialog__headerbtn {
    font-size: 18px;
    height: 58px;
  }
}
</style>

<template>
  <el-dialog
    v-model="visible"
    class="partner-join-process-dialog-wrapper"
    :title="joinData.corpType === JOIN_TYPE_ENUM.CITY_PARTNER.value ? '城市合伙人入驻流程' : '推广大使入驻流程'"
    width="976px"
    append-to-body
    :before-close="close"
    :close-on-click-modal="false"
  >
    <!-- 空白loading -->
    <div v-if="activeStep === null" v-loading="activeStep === null" class="empty-box" element-loading-background="rgba(0, 0, 0, 0)" />
    <template v-else>
      <!-- 流程步骤 -->
      <el-steps :active="activeStep" align-center>
        <el-step v-for="item in stepList" :key="item.id" :title="item.title">
          <template #icon>
            <StepIcon :step="item.id" :active-step="activeStep" :step-status="stepStatus" />
          </template>
        </el-step>
      </el-steps>
      <!-- 基本信息 -->
      <BasicInfo
        v-if="activeStep === JOIN_STEP_MAP[joinData.corpType].BASIC_INFO.id"
        :join-data="joinData"
        :join-type="joinData.corpType"
        :setJoinData="setJoinData"
        :close="close"
        :nextStep="nextStep"
      />
      <!-- 返佣账号信息 -->
      <RebateAccountInfo
        v-if="activeStep === JOIN_STEP_MAP[joinData.corpType].REBATE_ACCOUNT_INFO.id"
        :close="close"
        :join-data="joinData"
        :setJoinData="setJoinData"
        :prevStep="prevStep"
        :nextStep="nextStep"
      />
      <!-- 付款信息确认 只有城市合伙人显示-->
      <PaymentInfo
        v-if="Number(joinData.corpType) === JOIN_TYPE_ENUM.CITY_PARTNER.value && activeStep === CITY_PARTNER_STEP.PAYMENT_INFO.id"
        :close="close"
        :join-data="joinData"
        :prevStep="prevStep"
        :nextStep="nextStep"
      />

      <!-- 协议签署 -->
      <SignAgreement
        v-if="activeStep === JOIN_STEP_MAP[joinData.corpType].SIGN_AGREEMENT.id"
        :close="close"
        :join-data="joinData"
        :resubmit="resubmit"
        :prevStep="prevStep"
        :nextStep="nextStep"
      />
    </template>
  </el-dialog>
</template>

<script setup>
import { computed, nextTick, onMounted, ref } from 'vue'
import BasicInfo from './common/basic-info.vue'
import PaymentInfo from './common/payment-info.vue'
import RebateAccountInfo from './common/rebate-account-info.vue'
import SignAgreement from './common/sign-agreement.vue'
import StepIcon from './common/step-icon.vue'
import { JOIN_TYPE_ENUM } from '@/constants/common'
import { useUserStore } from '@/stores/index'
import userApi from '@/apis/user'
import event from '@/event/index'
import { CLOSE_JOIN_CORP_DIALOG, REFRESH_JOIN_CORP_STATUS } from '@/event/modules/site'
import { isNull } from '@/utils/utils'
import { AMBASSADOR_STEP_ARRAY, assignNonNullValues, CITY_PARTNER_STEP, CITY_PARTNER_STEP_ARRAY, JOIN_LOCAL, JOIN_STATUS, JOIN_STEP_MAP } from './common/data'

const userInfo = useUserStore()
//步骤
const stepList = computed(() => {
  if (Number(joinData.value.corpType) === JOIN_TYPE_ENUM.CITY_PARTNER.value) {
    //城市合伙人
    return CITY_PARTNER_STEP_ARRAY
  } else {
    //推广大使
    return AMBASSADOR_STEP_ARRAY
  }
})

const activeStep = ref(null) // 激活到哪个步骤
const stepStatus = ref(JOIN_STATUS.WAIT_SUBMIT) // 步骤状态 默认待提交
const visible = ref(false) // 是否显示窗口
const joinType = ref(null) // 手动选择的加盟类型 0:城市合伙人 1:推广大使

//入驻信息
const joinData = ref({})

//查询入驻信息
const getPartnerJoinInfo = async () => {
  const res = await userApi.getPartnerJoinInfo({ corpId: userInfo?.userInfo?.corpId })

  stepStatus.value = res.status || JOIN_STATUS.WAIT_SUBMIT //步骤状态 默认待提交
  const { corpOpenInfo, rebateInfo, invoiceInfo, ...restRes } = res || {}
  const joinFormData = JOIN_LOCAL.getJoinFormData()
  Object.assign(joinData.value, joinFormData, !isNull(joinType.value) ? { corpType: joinType.value } : {}, {
    cooperationCityCodes: res.corpProvinceCode ? [res.corpProvinceCode, res.corpCityCode] : [], //合作城市代码集合
  }) //合并本地缓存数据
  assignNonNullValues(joinData.value, restRes, corpOpenInfo, rebateInfo, invoiceInfo, !isNull(joinType.value) ? { corpType: joinType.value } : {}) //合并接口返回数据
  JOIN_LOCAL.setJoinFormData(joinData.value)
}

//打开窗口
const open = async (params) => {
  await nextTick()
  visible.value = true
  joinData.value.corpType = Number(params?.joinType) //加盟类型 0:城市合伙人 1:推广大使
  joinType.value = Number(params?.joinType) //暂存手动选择的加盟类型 用于替换接口返回默认数据

  await getPartnerJoinInfo()

  setStep()
}

//关闭窗口
const close = () => {
  activeStep.value = null
  visible.value = false
}

//下一步
const nextStep = async (params) => {
  if (params?.step) {
    //手动指定下一步
    activeStep.value = params.step
    return
  }
  //查询入驻状态数据
  await getPartnerJoinInfo()
  //设置步骤
  setStep()
}

//上一步
const prevStep = () => {
  activeStep.value--
}

//加盟流程步骤设置
const setStep = () => {
  const { status } = joinData.value || {}
  switch (status) {
    case JOIN_STATUS.WAIT_SUBMIT: //待提交资料
      activeStep.value = JOIN_STEP_MAP[joinData.value.corpType].BASIC_INFO.id //基本信息
      break
    case JOIN_STATUS.WAIT_PAY: //已提交待付款
      activeStep.value = CITY_PARTNER_STEP.PAYMENT_INFO.id //付款信息确认 *固定使用企业流程步骤枚举
      break
    case JOIN_STATUS.WAIT_AUDIT: //已付款待审核
    case JOIN_STATUS.AUDIT_REJECT: //已审核被驳回
    case JOIN_STATUS.SIGN_EXPIRED: //签署过期
    case JOIN_STATUS.WAIT_SIGN: //已审核待签署
    case JOIN_STATUS.SIGN_START: //已发起签署
    case JOIN_STATUS.REJECT_SIGN: //拒签
      activeStep.value = JOIN_STEP_MAP[joinData.value.corpType].SIGN_AGREEMENT.id //协议签署
      break
    case JOIN_STATUS.SUCCESS: //成功
      activeStep.value = JOIN_STEP_MAP[joinData.value.corpType].SUCCESS.id //入驻成功
      break
    default:
      activeStep.value = JOIN_STEP_MAP[joinData.value.corpType].BASIC_INFO.id //基本信息
  }
}

//重新提交
const resubmit = () => {
  activeStep.value = CITY_PARTNER_STEP.PAYMENT_INFO.id //付款信息确认 *固定使用企业流程步骤枚举
}

onMounted(() => {
  event.on(REFRESH_JOIN_CORP_STATUS, () => {
    if (visible.value) {
      nextStep()
    }
  })
  event.on(CLOSE_JOIN_CORP_DIALOG, () => {
    close()
  })
})

const setJoinData = (data) => {
  //更新joinData数据
  Object.assign(joinData.value, data)
  //设置本地缓存数据
  JOIN_LOCAL.setJoinFormData(joinData.value)
}

defineExpose({
  open,
  close,
})
</script>
